import { cn } from '@/lib/utils'

type ButtonVariant = 'primary' | 'primaryOnDark' | 'ink' | 'outline' | 'outlineOnDark'

type ButtonSize = 'sm' | 'md' | 'lg'

interface ButtonStyleOptions {
    variant?: ButtonVariant
    size?: ButtonSize
    className?: string
}

const BASE = 'group/button inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-full font-bold uppercase tracking-[0.06em] whitespace-nowrap transition-colors duration-200 focus-visible:outline-2 focus-visible:outline-offset-4 disabled:pointer-events-none disabled:opacity-60'

const VARIANTS: Record<ButtonVariant, string> = {
    primary: 'bg-primary text-primary-foreground hover:bg-foreground hover:text-background focus-visible:outline-foreground',
    primaryOnDark: 'bg-primary text-primary-foreground hover:bg-background hover:text-foreground focus-visible:outline-background',
    ink: 'bg-foreground text-background hover:bg-primary hover:text-primary-foreground focus-visible:outline-foreground',
    outline: 'border-2 border-foreground text-foreground hover:bg-foreground hover:text-background focus-visible:outline-foreground',
    outlineOnDark: 'border-2 border-background text-background hover:bg-background hover:text-foreground focus-visible:outline-background'
}

const SIZES: Record<ButtonSize, string> = {
    sm: 'h-10 px-4 text-xs',
    md: 'h-12 px-6 text-sm',
    lg: 'h-14 px-7 text-sm sm:h-16 sm:px-8 sm:text-base'
}

// Shared pill button look for links and buttons. Pair with an icon that uses
// `group-hover/button:` to animate on hover.
export const buttonStyles = ({ variant = 'primary', size = 'md', className }: ButtonStyleOptions = {}): string =>
    cn(BASE, VARIANTS[variant], SIZES[size], className)
